import {Component, Input, input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {ProjectProfileGroup} from "../../../../api/db/entities/ProjectProfileGroup";
import {ProjectDescriptor, ProjectDescriptorCategory} from "../../../../api/project_schemas";
import {ProjectProfileSelection} from "../../../../api/db/entities/ProjectProfileSelection";
import { ThemeUtils } from '@primeuix/themes';

@Component({
    standalone: true,
    template: 'Superclass for all profile components. Do not use directly.'
})
export abstract class AbstractProfileComponent implements OnInit  {

    readonly profileGroup = input.required<ProjectProfileGroup>();
    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() projectDescriptor!: ProjectDescriptor;
    readonly descriptorCategory = input.required<ProjectDescriptorCategory>();

    protected holder: ProjectProfileSelection;

    constructor() {

    }

    ngOnInit(): void {
        //console.log("Does the profile group make it? ", this.profileGroup());

        /*if (!this.profileGroup().profileSelections) {
            this.profileGroup().profileSelections = [];
        }*/
        //Make sure the entry already exists in the group
        this.holder = this.profileGroup().profileSelections.find(
            (selection) => (
                selection.categoryUniqueId === this.descriptorCategory().uniqueId &&
                selection.descriptorUniqueId === this.projectDescriptor.uniqueId
            )
        );

        //console.log("HERE IS THE HOLDER BEFORE EMPTY FILL", this.holder);

        if (!this.holder) {
            this.holder = new ProjectProfileSelection();
            this.holder.categoryUniqueId = this.descriptorCategory().uniqueId;
            this.holder.descriptorUniqueId = this.projectDescriptor.uniqueId;
            this.holder.value = '';
            this.profileGroup().profileSelections.push(this.holder);
            console.log(this.profileGroup());
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['profileGroup']) {
                this.holder = this.profileGroup().profileSelections.find(
                (selection) => (
                    selection.categoryUniqueId === this.descriptorCategory().uniqueId &&
                    selection.descriptorUniqueId === this.projectDescriptor.uniqueId
                )
            );

            //console.log("HERE IS THE HOLDER BEFORE EMPTY FILL", this.holder);

            if (!this.holder) {
                this.holder = new ProjectProfileSelection();
                this.holder.categoryUniqueId = this.descriptorCategory().uniqueId;
                this.holder.descriptorUniqueId = this.projectDescriptor.uniqueId;
                this.holder.value = '';
                this.profileGroup().profileSelections.push(this.holder);
                console.log(this.profileGroup());
            }
        }
    }
}
